// @see https://github.com/mobxjs/mobx-state-tree
import { types } from 'mobx-state-tree'
import { me } from '../api'

// noinspection JSCheckFunctionSignatures
const UserStore = types.model({
  login: types.optional(types.boolean, false),
  confirmed: types.optional(types.boolean, false),
  token: types.optional(types.string, ''),
  google_id_token: types.optional(types.string, ''),
  facebook_user_id: types.optional(types.string, ''),
  image_url: types.optional(types.string, ''),
  prename: types.optional(types.string, ''),
  surname: types.optional(types.string, ''),
  birthdate: types.optional(types.string, ''),
  city: types.optional(types.string, ''),
  email: types.optional(types.string, ''),
  gender: types.optional(types.string, ''),
  job: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  created_at: types.optional(types.string, ''),
  updated_at: types.optional(types.string, '')
}).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get shortName () {
      let surname = self.surname ? self.surname.charAt(0) + '.' : ''
      return self.prename + ' ' + surname
    },
    get fullName () {
      return self.prename + ' ' + self.surname
    }
  })
).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    setToken (token) {
      console.log('setToken')
      self.token = token
      me(token).then(
        self.fetchUser // Right way fetch data
      )
    },
    fetchUser (user) {
      if (!user) {
        self.clean()
        return false
      }
      
      self.login = true
      console.log('UserStore - fetchUser - user', user)
      console.log('UserStore - fetchUser - self', self)
      Object.keys(user).map(function (key) {
        if (key === 'description') {
          console.log('fetchUser - description self[key]', self[key])
          console.log('fetchUser - description user[key]', user[key])
        }
        let new_value = user[key]
        if (typeof new_value === 'undefined') {
          return false
        }
        if (new_value === null) {
          new_value = ''
        }

        self[key] = new_value
      })
    },
    clean () {
      console.log('UserStore - clean() - self:', self)
      self.login = false
      self.token = ''
      self.google_id_token = ''
      self.facebook_user_id = ''
      self.image_url = ''
      self.prename = ''
      self.surname = ''
      self.birthdate = ''
      self.city = ''
      self.email = ''
      self.gender = ''
      self.job = ''
      self.description = ''
      self.created_at = ''
      self.updated_at = ''
      // TODO: Remove all data
    }
  })
)

export default UserStore



// WEBPACK FOOTER //
// ./src/stores/UserStore.js